import { render, staticRenderFns } from "./UpdateVat.vue?vue&type=template&id=cca48c36&scoped=true"
import script from "./UpdateVat.vue?vue&type=script&lang=js"
export * from "./UpdateVat.vue?vue&type=script&lang=js"
import style0 from "./UpdateVat.vue?vue&type=style&index=0&id=cca48c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca48c36",
  null
  
)

export default component.exports